export default __webpack_public_path__ + "static/incendiarias-85df6abde233b11807c7fb1ef72b8323.jpg";